module.exports = __webpack_public_path__ + "static/media/salt-desert.2df881b9.jpg";